// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items/{itemKey}.
 * Redirects to /catalog/items/{itemKey}.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/$itemKey/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/catalog/items/$itemKey',
      params: { itemKey: params.itemKey },
      search: true,
    });
  },
});
